import * as Sentry from '@sentry/browser';

export function onlineStatusIntegration() {
  return {
    name: 'OnlineStatusIntegration',
    setupOnce() {
      if ('onLine' in window.navigator) {
        window.addEventListener('offline', () => {
          Sentry.addBreadcrumb({
            category: 'connectivity',
            message: 'Browser went offline',
            level: 'info',
          });
        });

        window.addEventListener('online', () => {
          Sentry.addBreadcrumb({
            category: 'connectivity',
            message: 'Browser went online',
            level: 'info',
          });
        });
      }
    },
  };
}
